var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon11BlogCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 6.28a1 1 0 0 1 .02 1.42l-9.77 10a1 1 0 0 1-1.48-.05l-4.23-5a1 1 0 0 1 1.52-1.3l3.53 4.16 9-9.2a1 1 0 0 1 1.4-.03z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0xOS43IDYuMjhhMSAxIDAgMCAxIC4wMiAxLjQybC05Ljc3IDEwYTEgMSAwIDAgMS0xLjQ4LS4wNWwtNC4yMy01YTEgMSAwIDAgMSAxLjUyLTEuM2wzLjUzIDQuMTYgOS05LjJhMSAxIDAgMCAxIDEuNC0uMDN6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4NCjwvc3ZnPg0K";
export { SvgIcon11BlogCheckmark as ReactComponent };